export default "__VITE_ASSET__CvJ7yTML__"